import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

const REMEMBER_KEY = "coravu_remember_me";

/** `false` = sessionStorage on web (tab-scoped); `true` = localStorage on web (persists). Native always uses AsyncStorage. */
function webPickStorage(): Storage | null {
  if (Platform.OS !== "web" || typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(REMEMBER_KEY);
    if (v === "0") return window.sessionStorage;
    return window.localStorage;
  } catch {
    return null;
  }
}

export function setRememberMePreference(remember: boolean): void {
  const val = remember ? "1" : "0";
  if (Platform.OS === "web" && typeof window !== "undefined") {
    try {
      window.localStorage.setItem(REMEMBER_KEY, val);
    } catch {
      /* ignore */
    }
    return;
  }
  void AsyncStorage.setItem(REMEMBER_KEY, val);
}

export async function getRememberMePreference(): Promise<boolean> {
  if (Platform.OS === "web" && typeof window !== "undefined") {
    try {
      return window.localStorage.getItem(REMEMBER_KEY) !== "0";
    } catch {
      return true;
    }
  }
  const v = await AsyncStorage.getItem(REMEMBER_KEY);
  return v !== "0";
}

/**
 * Supabase auth storage: on web, routes to sessionStorage when remember-me is off
 * so the session does not survive new tabs; otherwise localStorage / AsyncStorage.
 */
export const supabaseAuthStorage = {
  getItem: (key: string) => {
    const w = webPickStorage();
    if (w) return Promise.resolve(w.getItem(key));
    return AsyncStorage.getItem(key);
  },
  setItem: (key: string, value: string) => {
    const w = webPickStorage();
    if (w) {
      w.setItem(key, value);
      return Promise.resolve();
    }
    return AsyncStorage.setItem(key, value);
  },
  removeItem: (key: string) => {
    const w = webPickStorage();
    if (w) {
      w.removeItem(key);
      try {
        const other = w === window.localStorage ? window.sessionStorage : window.localStorage;
        other.removeItem(key);
      } catch {
        /* ignore */
      }
      return Promise.resolve();
    }
    return AsyncStorage.removeItem(key);
  },
};
